import { FC, PropsWithChildren } from 'react';

import styles from './WrapperContentCoWork.styles.m.css';

export const WrapperContentCoWork: FC<PropsWithChildren> = ({ children }) => {
  return <div className={styles.container}>{children}</div>;
};
